import { isArray } from 'lodash-es';
import notificationTypes from '../components/formNotification/notificationTypes';

// Przemapowanie błędu do komunikatu rozumianego przez komponent FormNotification
const mapErrorToMessage = (message) => {
  if (message) {
    return { value: message, type: notificationTypes.ERROR };
  }
  if (Array.isArray(message)) {
    return message.map((messageItem) => ({ value: messageItem, type: notificationTypes.ERROR }));
  }

  return null;
};

// Jako że błędy z api przychodza w różnej formie - wyszukuję je w róznych miejscach obiektu
export const interceptErrorMessage = (exception) => {
  const plainMessage = typeof exception?.response?.data === 'string' && exception?.response?.data ? exception.response.data : undefined;
  const message = exception?.response?.data?.userMessage ?? exception?.response?.data?.message ?? plainMessage;

  if (message) {
    return mapErrorToMessage(message);
  }

  if (isArray(exception?.response?.data) && exception.response.data[0]?.userMessage) {
    return exception.response.data.map((item) => mapErrorToMessage(item.userMessage));
  }

  if (exception?.message) {
    return mapErrorToMessage(exception.message);
  }

  return mapErrorToMessage('Wystapił błąd podczas pobierania danych.');
};
